// Dependencias generales
import React from "react";
import { useEffect, useState } from 'react';
import ReactGA from "react-ga4";
import imgNoResultsDark from '../../../img/dark-theme/empty-state.svg'

import Loader from '../../../components/Utils/Loader'
import SharedInstallers from "./Installer/SharedInstallers";
import SharedUsers from "./User/SharedUsers";

const endpointHelias = "https://9m4y8iz04h.execute-api.eu-west-3.amazonaws.com/prod"
const postListInstallationSharedUsersInstallers = endpointHelias+"/Helias/V0/Configuration/postListInstallationSharedUsersInstallers"
const postUnshareInstallation = endpointHelias+"/Helias/V0/Configuration/postUnshareInstallation"

var initialConfigCommonJS = require("../../../js/initialConfigCommon.js");
var generalCommonJS = require("../../../js/generalCommon.js")

const ManageSharedInstallation = (params) => {
  
  const [timestampUsersInstallersList, settimestampUsersInstallersList] = useState(0)
  const [sharedInstallationsWithUsers, setSharedInstallationsWithUsers] = useState([])
  const [sharedInstallationsWithInstallers, setSharedInstallationsWithInstallers] = useState([])

  useEffect(() => {      

    cargarDatosComparticionActual()

    console.log("Página para compartir con usuario cargada correctamente.")
  }, [timestampUsersInstallersList]);

  function cargarDatosComparticionActual(){

    var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
    var lastAuthUserIdToken = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".idToken")        

    document.getElementById("loaderManageSharing").className = document.getElementById("loaderManageSharing").className.replaceAll(" hidden","")

    var jsonPeticion = {
      "accountID": localStorage.getItem("accountID"),
      "installationID": localStorage.getItem("installationId"),
     }
  
    // Guardo la información  
    var xhttp = new XMLHttpRequest();  
      xhttp.open("POST", postListInstallationSharedUsersInstallers, true);        
      xhttp.setRequestHeader('Content-Type', "application/json");
      xhttp.setRequestHeader('Authorization', lastAuthUserIdToken);
      var data = JSON.stringify(jsonPeticion);
      xhttp.onreadystatechange = function() {
        if (this.readyState === 4 && this.status === 200) {
          var jsonRespuesta = JSON.parse(this.responseText)
  
          if(jsonRespuesta.statusCode === "403"){                   
            initialConfigCommonJS.mostrarMensajeInformativo("No tiene permisos para realizar la operación.","negative")
          }
          else{          
            //Si recibo datos ya configurados lo cargo  
            setSharedInstallationsWithUsers(jsonRespuesta.body.Users)
            setSharedInstallationsWithInstallers(jsonRespuesta.body.Installers)

            localStorage.setItem("currentSharingStatus", JSON.stringify(jsonRespuesta.body))

            document.getElementById("loaderManageSharing").className += " hidden"

            //Si no hay datos configurados entonces no hago nada  
            console.log("Información de compartición cargada correctamente")
          }
        }
  
        if (this.readyState === 4 && this.status !== 200) {      
          initialConfigCommonJS.gestionarRespuestaPeticionErronea(this.status)          
        }
      }
      xhttp.send(data);      
  }

  function mostrarPestaña(pestaña){
    if(pestaña === "Usuarios"){
      document.getElementById("pestañaInstalacionCompartidaUsuarios").checked = true
      document.getElementById("pestañaInstalacionCompartidaUsuarios").className = document.getElementById("pestañaInstalacionCompartidaUsuarios").className.replaceAll(" hidden", "")        
      document.getElementById("pestañaInstalacionCompartidaInstaladores").className = " hidden"
    }
    else{
      document.getElementById("pestañaInstalacionCompartidaUsuarios").className = " hidden"
      document.getElementById("pestañaInstalacionCompartidaInstaladores").checked = true
      document.getElementById("pestañaInstalacionCompartidaInstaladores").className = document.getElementById("pestañaInstalacionCompartidaInstaladores").className.replaceAll(" hidden", "")
    }
  }  

  function dejarDeCompartirInstalacion(idInstalacion, idCuenta, idInstalador){

    var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
    var lastAuthUserIdToken = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".idToken")        

    document.getElementById("loaderManageSharing").className = document.getElementById("loaderManageSharing").className.replaceAll(" hidden","")

    var jsonPeticion = {
      "ownerAccountID": localStorage.getItem("accountID"),
      "installationID": idInstalacion,
      "sharedAccountID": idCuenta,
      "installerID": idInstalador
    }

    var tipoUsuario = ""

    if(idInstalador === ""){
      tipoUsuario = "usuario"
    }
    else{
      tipoUsuario = "instalador"
    }

    // Guardo la información  
    var xhttp = new XMLHttpRequest();  
      xhttp.open("POST", postUnshareInstallation, true);        
      xhttp.setRequestHeader('Content-Type', "application/json");
      xhttp.setRequestHeader('Authorization', lastAuthUserIdToken);
      var data = JSON.stringify(jsonPeticion);
      xhttp.onreadystatechange = function() {
        if (this.readyState === 4 && this.status === 200) {
          var jsonRespuesta = JSON.parse(this.responseText)
  
          if(jsonRespuesta.statusCode === "403"){                   
            initialConfigCommonJS.mostrarMensajeInformativo("No tiene permisos para realizar la operación.","negative")
          }
          else{          
            document.getElementById("loaderManageSharing").className += " hidden"
                        
            settimestampUsersInstallersList(new Date().getTime())
            
            initialConfigCommonJS.mostrarMensajeInformativo("Se ha dejado de compartir la instalación con este "+tipoUsuario+".","positive")

            generalCommonJS.registrarEventoAnalitica(ReactGA, 'CONFIGURACIÓN', 'DESCOMPARTIR - Con '+tipoUsuario, "", "")

            //Si no hay datos configurados entonces no hago nada  
            console.log("Descompartición de instalación realizada correctamente.")
          }
        }
  
        if (this.readyState === 4 && this.status !== 200) {      
          initialConfigCommonJS.gestionarRespuestaPeticionErronea(this.status)          
        }
      }
      xhttp.send(data);      

  }

  return (          
    
    <main id="divMainContenedorStep">      

      <section className="step">

        <fieldset className="radio multiple">
          <div className="tabs">
            <input type="radio" name="rules-tabs" id="usersSharedInstallations" onClick={() => mostrarPestaña("Usuarios")} defaultChecked/>
            <label className="tab" htmlFor="usersSharedInstallations">
              <span className="label">Usuarios<span className="counter">( {sharedInstallationsWithUsers.length} )</span></span>
            </label>

            <input type="radio" name="rules-tabs" id="installersSharedInstallations" onClick={() => mostrarPestaña("Instaladores")}/>
            <label className="tab" htmlFor="installersSharedInstallations">
              <span className="label">Empresas <span className="counter">( {sharedInstallationsWithInstallers.length} )</span></span>
            </label>

          </div>
        </fieldset>

        <fieldset style={{paddingTop: "20px"}}>

          <fieldset id="pestañaInstalacionCompartidaUsuarios">                

            <button className="button primary full-width" onClick={() => params.seleccionarOpcionSharing("compartirConUsuario")}>Compartir con otro usuario</button>

            { sharedInstallationsWithUsers.length > 0 ? 
              <SharedUsers listadoUsuariosCompartidos={sharedInstallationsWithUsers} dejarDeCompartirInstalacion={dejarDeCompartirInstalacion}/>                      
            :
            <div id="mensajeSinReglasConfiguradas" className="message medium empty">
              <picture>
                <source srcSet={imgNoResultsDark} media="(prefers-color-scheme: dark)"/>
                  <img src={imgNoResultsDark} alt=""/>
              </picture>
              <h1 className="title">Actualmente no tienes esta instalación compartida con ningún usuario</h1>                        
            </div>
            }
            
          </fieldset>
          
          <fieldset id="pestañaInstalacionCompartidaInstaladores" className=" hidden">                

            <button className="button primary full-width" onClick={() => params.seleccionarOpcionSharing("compartirConInstalador")}>Compartir con otra empresa</button>

            { sharedInstallationsWithInstallers.length > 0 ? 
              <SharedInstallers listadoInstaladoresCompartidos={sharedInstallationsWithInstallers} dejarDeCompartirInstalacion={dejarDeCompartirInstalacion}/>
            :
            <div id="mensajeSinReglasConfiguradas" className="message medium empty">
              <picture>
                <source srcSet={imgNoResultsDark} media="(prefers-color-scheme: dark)"/>
                  <img src={imgNoResultsDark} alt=""/>
              </picture>
              <h1 className="title">Actualmente no tienes esta instalación compartida con ningún instalador</h1>                        
            </div>
            }
          </fieldset>

        </fieldset>

        <Loader Id="loaderManageSharing" Mensaje=""/>
        
        </section>

    </main>
    
  )
}

export default ManageSharedInstallation